// src/components/Footer.tsx

import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="mobile-hide-footer bg-gray-50 text-gray-700 py-4 md:py-5 px-4 md:px-5 font-sans border-t border-gray-300 mt-auto">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-7xl mx-auto pb-3">
        {/* Company Section */}
        <div>
          <h3 className="text-base md:text-lg mb-3 md:mb-4 text-gray-600 font-medium">Company</h3>
          <ul className="space-y-2.5">
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">About</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Careers</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Mobile</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Blog</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">How we work</a></li>
          </ul>
        </div>

        {/* Contact Section */}
        <div>
          <h3 className="text-base md:text-lg mb-3 md:mb-4 text-gray-600 font-medium">Contact</h3>
          <ul className="space-y-2.5">
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Help/FAQ</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Press</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Affiliates</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Hotel owners</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Partners</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Advertise with us</a></li>
          </ul>
        </div>

        {/* More Section */}
        <div>
          <h3 className="text-base md:text-lg mb-3 md:mb-4 text-gray-600 font-medium">More</h3>
          <ul className="space-y-2.5">
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Airline fees</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Airlines</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Low fare tips</a></li>
            <li><a href="#" className="text-gray-700 hover:text-primary transition-colors">Badges & Certificates</a></li>
          </ul>
        </div>

        {/* App Section */}
        <div>
          <h3 className="text-base md:text-lg mb-3 md:mb-4 text-gray-600 font-medium">Get the Travel App</h3>
          <div className="flex flex-col mt-1.5 md:mt-2.5">
            <a href="#" className="bg-gray-800 text-white text-center py-2 px-2.5 rounded mb-2 hover:bg-primary transition-colors text-sm md:text-base">
              Get it on Google Play
            </a>
            <a href="#" className="bg-gray-800 text-white text-center py-2 px-2.5 rounded hover:bg-primary transition-colors text-sm md:text-base">
              Download on the App Store
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="text-center px-2">
        <div className="flex justify-center items-center mb-4">
          {/* Add your logo images here */}
        </div>
        <div className="text-xs md:text-sm text-gray-500">
          <span>© 2024 Travel App. All rights reserved. </span>
          <a href="#" className="text-gray-700 mx-1 hover:text-primary">Privacy</a>
          <span>·</span>
          <a href="#" className="text-gray-700 mx-1 hover:text-primary">Terms</a>
          <span>·</span>
          <a href="#" className="text-gray-700 mx-1 hover:text-primary">Site Map</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
